export const getAmbientColors = () => ({
  2: ['rgb(215,25,28)', 'rgb(26,150,65)'],
  3: ['rgb(215,25,28)', 'rgb(255,255,192)', 'rgb(26,150,65)'],
  4: ['rgb(215,25,28)', 'rgb(254,201,129)', 'rgb(196,230,135)', 'rgb(26,150,65)'],
  5: ['rgb(215,25,28)', 'rgb(253,174,97)', 'rgb(255,255,192)', 'rgb(166,217,106)', 'rgb(26,150,65)'],
  6: ['rgb(215,25,28)', 'rgb(246,144,83)', 'rgb(255,223,154)', 'rgb(220,240,158)', 'rgb(138,204,98)', 'rgb(26,150,65)'],
  7: ['rgb(215,25,28)', 'rgb(241,124,74)', 'rgb(254,201,129)', 'rgb(255,255,192)', 'rgb(196,230,135)', 'rgb(119,195,92)', 'rgb(26,150,65)'],
});

const getAmbientBreaks = (ambient) => {
  const explicitBreaks = Number(ambient?.params?.breaks ?? ambient?.params?.num_classes);

  if (Number.isFinite(explicitBreaks) && explicitBreaks >= 2) {
    return explicitBreaks;
  }

  const classIndexes = (ambient?.geojson?.features || [])
    .map((feature) => Number(feature?.properties?.cls))
    .filter(Number.isFinite);
  const maxClassIndex = Math.max(...classIndexes);

  if (Number.isFinite(maxClassIndex)) {
    return maxClassIndex + 1;
  }

  return 2;
};

const getAmbientRamp = (ambient) => {
  const colors = getAmbientColors();
  const breaks = getAmbientBreaks(ambient);

  return colors[breaks] || colors[Math.min(Math.max(breaks, 2), 7)] || colors[2];
};

export const paintAmbientGeojson = (ambient) => {
  if (!ambient?.geojson?.features?.length) {
    return null;
  }

  const colors = getAmbientRamp(ambient);
  const painted = Object.assign({}, ambient.geojson);
  painted.features = painted.features.map((feature) => {
    const nextFeature = { ...feature, properties: { ...feature.properties } };
    const classIndex = Number(feature?.properties?.cls);
    const safeIndex = Number.isFinite(classIndex)
      ? Math.min(Math.max(classIndex, 0), colors.length - 1)
      : 0;

    nextFeature.properties.color = colors[safeIndex];
    return nextFeature;
  });

  return painted;
};

export const applyAmbientToMap = ({
  ambient,
  landId,
  mapLayers,
  mapLegendContext,
  addOpenedAmbients,
}) => {
  const paintedAmbient = paintAmbientGeojson(ambient);

  if (!paintedAmbient || !landId) {
    return false;
  }

  addOpenedAmbients(landId);
  mapLayers.fit(landId);
  mapLegendContext.handleAmbient(landId, ambient);
  mapLayers.land.ambient.remove({ landId });
  mapLayers.land.ambient.add({ landId, geojson: paintedAmbient });

  return true;
};
